import { useContext } from "react";
import { MapContext } from "./MapContext";

function useMap() {
    const context = useContext(MapContext);
    if (!context) {
        throw Error("No Map Context!");
    }

    return context;
}

export default useMap;
